(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nlm-ai-inbox-assistant"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = window.NLM_AI_INBOX_ASSISTANT;
    const root = document.getElementById("nlm-ai-inbox-assistant");

    if (!root || !config || !config.endpoint) return;

    const storagePrefix = "nlm_ai_chat_";
    const sessionKey = `${storagePrefix}session`;
    const historyKey = `${storagePrefix}history`;
    const sessionId =
      window.localStorage.getItem(sessionKey) ||
      (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()));
    window.localStorage.setItem(sessionKey, sessionId);

    let history = readHistory();
    let busy = false;
    let inboxFallbackShown = false;
    let nativeLauncherAttached = false;
    let nativeLauncherInterval = null;
    let nativeLauncherObserver = null;
    let nativeLauncherResizeAttached = false;

    root.hidden = false;
    root.innerHTML = `
      <button class="nlm-ai-chat__button" type="button" aria-expanded="false">
        <span class="nlm-ai-chat__spark" aria-hidden="true">AI</span>
        <span></span>
      </button>
      <section class="nlm-ai-chat__panel" aria-live="polite">
        <header class="nlm-ai-chat__header">
          <div>
            <p class="nlm-ai-chat__title"></p>
            <p class="nlm-ai-chat__subtitle"></p>
          </div>
          <button class="nlm-ai-chat__close" type="button"></button>
        </header>
        <div class="nlm-ai-chat__tabs" role="tablist">
          <button class="nlm-ai-chat__tab nlm-ai-chat__tab--ai is-active" type="button"></button>
          <button class="nlm-ai-chat__tab nlm-ai-chat__tab--support" type="button"></button>
        </div>
        <div class="nlm-ai-chat__messages"></div>
        <form class="nlm-ai-chat__form">
          <input class="nlm-ai-chat__input" type="text" autocomplete="off" maxlength="1800">
          <button class="nlm-ai-chat__send" type="submit"></button>
          <button class="nlm-ai-chat__handoff" type="button"></button>
        </form>
      </section>
    `;

    const button = root.querySelector(".nlm-ai-chat__button");
    const buttonLabel = button.querySelector("span:last-child");
    const panel = root.querySelector(".nlm-ai-chat__panel");
    const title = root.querySelector(".nlm-ai-chat__title");
    const subtitle = root.querySelector(".nlm-ai-chat__subtitle");
    const close = root.querySelector(".nlm-ai-chat__close");
    const messages = root.querySelector(".nlm-ai-chat__messages");
    const form = root.querySelector(".nlm-ai-chat__form");
    const input = root.querySelector(".nlm-ai-chat__input");
    const send = root.querySelector(".nlm-ai-chat__send");
    const handoff = root.querySelector(".nlm-ai-chat__handoff");
    const aiTab = root.querySelector(".nlm-ai-chat__tab--ai");
    const supportTab = root.querySelector(".nlm-ai-chat__tab--support");

    buttonLabel.textContent = config.texts.openLabel;
    title.textContent = config.texts.title;
    subtitle.textContent = config.texts.subtitle;
    close.textContent = "×";
    close.setAttribute("aria-label", config.texts.close);
    aiTab.textContent = config.texts.aiTab || "AI advisor";
    supportTab.textContent = config.texts.supportTab || config.texts.handoff;
    input.placeholder = config.texts.placeholder;
    send.textContent = config.texts.send;
    handoff.textContent = config.texts.handoff;

    if (!history.length) {
      appendMessage("assistant", config.texts.greeting, false);
    } else {
      history.forEach((item) => appendMessage(item.role, item.content, false));
    }

    button.addEventListener("click", () => openAiAssistant());
    close.addEventListener("click", () => setOpen(false));
    aiTab.addEventListener("click", () => setActiveTab("ai"));
    supportTab.addEventListener("click", () => handoffToInbox());
    handoff.addEventListener("click", () => handoffToInbox());
    startNativeLauncherBridge();

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const message = input.value.trim();
      if (!message || busy) return;

      input.value = "";
      appendMessage("user", message, true);
      await sendMessage(message);
    });

    function setOpen(open) {
      root.classList.toggle("is-open", open);
      button.setAttribute("aria-expanded", String(open));
      if (open) {
        window.setTimeout(() => input.focus(), 80);
      }
    }

    function openAiAssistant() {
      setOpen(true);
      setActiveTab("ai");
    }

    function setActiveTab(tab) {
      const aiActive = tab === "ai";
      aiTab.classList.toggle("is-active", aiActive);
      supportTab.classList.toggle("is-active", !aiActive);
      form.hidden = !aiActive;
      if (aiActive) {
        window.setTimeout(() => input.focus(), 80);
      }
    }

    function appendMessage(role, content, persist) {
      const item = document.createElement("div");
      item.className = `nlm-ai-chat__message nlm-ai-chat__message--${role}`;
      item.textContent = content;
      messages.appendChild(item);
      messages.scrollTop = messages.scrollHeight;

      if (persist && (role === "user" || role === "assistant")) {
        history.push({ role, content });
        history = history.slice(-8);
        window.localStorage.setItem(historyKey, JSON.stringify(history));
      }

      return item;
    }

    function readHistory() {
      try {
        const parsed = JSON.parse(window.localStorage.getItem(historyKey) || "[]");
        return Array.isArray(parsed) ? parsed.slice(-8) : [];
      } catch (_error) {
        return [];
      }
    }

    async function sendMessage(message) {
      setBusy(true);
      const status = appendMessage("status", config.texts.loading, false);

      try {
        const response = await fetch(config.endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sessionId,
            message,
            history: history.slice(-6),
            page: config.page
          })
        });

        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || response.statusText);

        status.remove();
        appendMessage("assistant", payload.reply || config.texts.error, true);
        root.classList.toggle("needs-handoff", Boolean(payload.handoff));
      } catch (_error) {
        status.remove();
        appendMessage("assistant", config.texts.error, true);
        root.classList.add("needs-handoff");
      } finally {
        setBusy(false);
      }
    }

    function setBusy(nextBusy) {
      busy = nextBusy;
      input.disabled = nextBusy;
      send.disabled = nextBusy;
    }

    function handoffToInbox() {
      setActiveTab("support");
      setOpen(false);

      if (openShopifyInbox()) {
        return;
      }

      window.setTimeout(() => {
        if (openShopifyInbox()) return;

        setOpen(true);
        setActiveTab("support");

        if (!inboxFallbackShown) {
          const fallbackText = [config.texts.supportIntro, config.texts.inboxFallback].filter(Boolean).join("\n");
          appendMessage("assistant", fallbackText || config.texts.inboxFallback, true);
          inboxFallbackShown = true;
        }
      }, 180);
    }

    function startNativeLauncherBridge() {
      const tryAttach = () => {
        const attached = attachToNativeShopifyChat();
        if (attached && nativeLauncherInterval) {
          window.clearInterval(nativeLauncherInterval);
          nativeLauncherInterval = null;
        }
        return attached;
      };

      if (tryAttach()) return;

      let attempts = 0;
      nativeLauncherInterval = window.setInterval(() => {
        attempts += 1;
        const attached = tryAttach();
        if (attached || attempts > 80) {
          window.clearInterval(nativeLauncherInterval);
          nativeLauncherInterval = null;
          if (!nativeLauncherAttached) root.classList.add("native-launcher-unavailable");
        }
      }, 250);
    }

    function attachToNativeShopifyChat() {
      const native = getNativeShopifyChat();
      const shadow = native.host?.shadowRoot;
      const activator = native.activator;
      const wrapper = native.wrapper;

      if (!shadow || !wrapper) return false;

      root.classList.add("has-native-launcher");
      nativeLauncherAttached = true;
      injectNativeLauncherStyles(shadow);

      let aiLauncher = shadow.getElementById("nlm-ai-native-launcher");
      if (!aiLauncher) {
        aiLauncher = document.createElement("button");
        aiLauncher.id = "nlm-ai-native-launcher";
        aiLauncher.type = "button";
        aiLauncher.className = "nlm-ai-native-launcher";
        aiLauncher.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          openAiAssistant();
        });
        wrapper.appendChild(aiLauncher);
      } else if (aiLauncher.parentElement !== wrapper) {
        wrapper.appendChild(aiLauncher);
      }

      aiLauncher.textContent = config.texts.openLabel || "AI";
      aiLauncher.setAttribute("aria-label", config.texts.aiTab || "AI advisor");
      const inboxLauncher = getVisibleInboxLauncher(native, aiLauncher);
      aiLauncher.hidden = Boolean(native.runtimeOpen || !inboxLauncher);
      positionFallbackLauncher(aiLauncher, native, inboxLauncher);

      if (activator && !activator.dataset.nlmAiBridge) {
        activator.dataset.nlmAiBridge = "true";
        activator.addEventListener("click", () => setOpen(false));
      }

      if (!nativeLauncherObserver) {
        nativeLauncherObserver = new MutationObserver(() => {
          window.setTimeout(attachToNativeShopifyChat, 50);
        });
        nativeLauncherObserver.observe(shadow, { attributes: true, childList: true, subtree: true });
      }

      if (!nativeLauncherResizeAttached) {
        nativeLauncherResizeAttached = true;
        window.addEventListener("resize", () => window.setTimeout(attachToNativeShopifyChat, 50), { passive: true });
      }

      return true;
    }

    function injectNativeLauncherStyles(shadow) {
      if (shadow.getElementById("nlm-ai-native-launcher-style")) return;

      const style = document.createElement("style");
      style.id = "nlm-ai-native-launcher-style";
      style.textContent = `
        .activator-nudge {
          display: flex !important;
          align-items: flex-end !important;
          gap: 8px !important;
        }

        #nlm-ai-native-launcher {
          position: fixed;
          left: calc(var(--shopify-chat-activator-offset, 20px) + 128px);
          bottom: 20px;
          z-index: 2147483647;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 54px;
          min-height: 46px;
          border: 0;
          border-radius: var(--shopify-chat-border-radius, 16px);
          padding: 0 15px;
          background: #d7fb63;
          color: #111827;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
          font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          font-size: 14px;
          font-weight: 850;
          line-height: 1;
          cursor: pointer;
          pointer-events: auto;
        }

        .activator-nudge #nlm-ai-native-launcher {
          position: static;
          left: auto;
          bottom: auto;
          z-index: auto;
        }

        #nlm-ai-native-launcher:hover {
          filter: brightness(0.96);
        }

        #nlm-ai-native-launcher[hidden] {
          display: none !important;
        }
      `;
      shadow.appendChild(style);
    }

    function positionFallbackLauncher(aiLauncher, native, inboxLauncher) {
      if (isElementVisible(native.activator) || native.runtimeOpen || aiLauncher.hidden) {
        aiLauncher.style.removeProperty("left");
        return;
      }

      const launcherWidth = aiLauncher.getBoundingClientRect().width || 54;
      const rect = inboxLauncher?.getBoundingClientRect();

      if (!rect?.width) {
        aiLauncher.style.removeProperty("left");
        return;
      }

      const maxLeft = Math.max(20, window.innerWidth - launcherWidth - 20);
      const left = Math.min(Math.max(20, rect.right + 8), maxLeft);
      aiLauncher.style.left = `${Math.round(left)}px`;
    }

    function getVisibleInboxLauncher(native, aiLauncher) {
      if (native.runtimeOpen) return null;

      const candidates = [
        native.activator,
        ...Array.from(native.wrapper?.children || []),
        ...Array.from(native.shadow?.querySelectorAll("iframe, button, [role='button']") || [])
      ].filter(Boolean);

      return candidates.find((element) => {
        if (element === aiLauncher || element.contains(aiLauncher) || aiLauncher?.contains(element)) return false;
        return isElementVisible(element) && isElementNearLauncherArea(element);
      }) || null;
    }

    function isElementVisible(element) {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== "none" && style.visibility !== "hidden";
    }

    function isElementNearLauncherArea(element) {
      const rect = element.getBoundingClientRect();
      return rect.bottom > window.innerHeight - 180 && rect.left < 220;
    }

    function getNativeShopifyChat() {
      const host = document.querySelector("shopify-chat, shopify-agent");
      const shadow = host?.shadowRoot;
      const activator = shadow?.querySelector("button[part='activator'], button.activator");
      const runtimeOpen = Boolean(shadow?.querySelector("shopify-agent-runtime[open]"));
      const wrapper =
        activator?.closest(".activator-nudge") ||
        shadow?.querySelector(".activator-nudge") ||
        shadow?.querySelector("#shopify-element-wrapper");

      return { host, shadow, activator, runtimeOpen, wrapper };
    }

    function openShopifyInbox() {
      const native = getNativeShopifyChat();
      if (native.runtimeOpen) return true;

      const inboxLauncher = getVisibleInboxLauncher(native, native.shadow?.getElementById("nlm-ai-native-launcher"));
      if (clickInboxLauncher(inboxLauncher)) return true;

      const selectors = [
        "[aria-label*='Chat']",
        "[aria-label*='chat']",
        "[aria-label*='Message']",
        "[title*='Chat']",
        "[title*='chat']",
        "button[class*='chat']",
        "button[class*='inbox']",
        "iframe[src*='inbox']",
        "iframe[title*='chat']",
        "iframe[title*='Chat']"
      ];

      for (const selector of selectors) {
        const elements = Array.from(document.querySelectorAll(selector)).filter((element) => {
          if (root.contains(element)) return false;
          const rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });

        for (const element of elements) {
          if (clickInboxLauncher(element)) return true;
        }
      }

      return false;
    }

    function clickInboxLauncher(element) {
      if (!element) return false;

      try {
        element.focus?.();
        element.dispatchEvent(new MouseEvent("pointerdown", { bubbles: true, cancelable: true, composed: true, view: window }));
        element.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true, composed: true, view: window }));
        element.dispatchEvent(new MouseEvent("mouseup", { bubbles: true, cancelable: true, composed: true, view: window }));
        element.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, composed: true, view: window }));
        element.click?.();
        return true;
      } catch (_error) {
        return false;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
